module.exports = __webpack_public_path__ + "static/media/BG1.d80f0e19.jpg";